"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSubscription = createSubscription;
exports.getIndividualCoachingBookings = getIndividualCoachingBookings;
exports.getSubscriptionById = getSubscriptionById;
exports.getSubscriptionList = getSubscriptionList;
exports.getSubscriptionStatistics = getSubscriptionStatistics;
exports.getSubscriptionUserRecords = getSubscriptionUserRecords;
exports.getSubscriptionUserRecordsStatistics = void 0;
exports.updateSubscription = updateSubscription;
var _request = _interopRequireDefault(require("@/utils/request"));
function createSubscription(token, data) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/v1/subscriptions',
    baseURL: process.env.VUE_APP_ORG_BASE_API,
    method: 'post',
    headers,
    data
  });
}
function getSubscriptionList(token, query) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const config = {
    url: '/v1/subscriptions',
    baseURL: process.env.VUE_APP_ORG_BASE_API,
    method: 'get',
    headers
  };
  if (query && Object.keys(query).length > 0) {
    config.params = query;
  }
  return (0, _request.default)(config);
}
function getSubscriptionById(token, id) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/v1/subscriptions/' + id,
    baseURL: process.env.VUE_APP_ORG_BASE_API,
    method: 'get',
    headers
  });
}
function updateSubscription(token, id, data) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/v1/subscriptions/' + id,
    baseURL: process.env.VUE_APP_ORG_BASE_API,
    method: 'put',
    headers,
    data
  });
}
function getSubscriptionUserRecords(token, id, params = {}) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/subscriptions/' + id + '/user-records',
    baseURL: process.env.VUE_APP_BASE_API,
    method: 'get',
    headers,
    params
  });
}
function getIndividualCoachingBookings(token, subscriptionId, userUuid) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/subscriptions/${subscriptionId}/individual-coaching-bookings/${userUuid}`,
    baseURL: process.env.VUE_APP_BASE_API,
    method: 'get',
    headers
  });
}
function getSubscriptionStatistics(token, id) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/subscriptions/' + id + '/statistics',
    baseURL: process.env.VUE_APP_BASE_API,
    method: 'get',
    headers
  });
}
const getSubscriptionUserRecordsStatistics = exports.getSubscriptionUserRecordsStatistics = getSubscriptionStatistics;